'use client';

import React, { useState } from 'react';

import { FormSubmissionModal } from '@/components/forms/FormSubmissionModal/FormSubmissionModal';
import {
  nutritionEnquirySchema,
  nutritionEnquiryDefaultValues,
  nutritionEnquiryFields,
} from '@/features/nutritionist/forms/nutritionEnquirySchema';

import PackagesSection from '@/components/sections/PackagesSection';
import type { PackagesSectionProps } from '@/components/sections/PackagesSection/types';

export default function NutritionistPackagesWithModal({
  data,
}: PackagesSectionProps): React.ReactElement {
  const [enquiryOpen, setEnquiryOpen] = useState(false);
  const [hasBeenOpened, setHasBeenOpened] = useState(false);
  const [enquiryTitle, setEnquiryTitle] = useState<string>(
    'Enquire about this package',
  );
  const [selectedPackage, setSelectedPackage] = useState<{
    title?: string;
    price?: string;
  } | null>(null);

  return (
    <>
      <PackagesSection
        data={data}
        showViewAllButton={false}
        categoryLabel="Weight Loss Management"
        includedLabel="Included Tests"
        onEnquire={(payload) => {
          setSelectedPackage({
            title: payload.title,
            price: payload.price,
          });
          setEnquiryTitle(
            payload.title
              ? `Enquire about ${payload.title}`
              : 'Enquire about this package',
          );
          setHasBeenOpened(true);
          setEnquiryOpen(true);
        }}
      />
      {hasBeenOpened && (
        <FormSubmissionModal
          open={enquiryOpen}
          onOpenChange={setEnquiryOpen}
          formId="nutritionEnquiry"
          schema={nutritionEnquirySchema}
          fields={nutritionEnquiryFields}
          defaultValues={nutritionEnquiryDefaultValues}
          title={enquiryTitle}
          description="Fill in your details and our team will contact you."
          submitLabel="Send enquiry"
          metadata={{
            serviceName: 'Nutritionist',
            pageType: 'service',
            source: 'nutrition-packages',
            packageName: selectedPackage?.title,
            packagePrice: selectedPackage?.price,
          }}
        />
      )}
    </>
  );
}
